var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNouserdata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M374.78,259.1c11.69,6.83,11.68,17.89,0,24.72s-30.65,6.82-42.34,0-11.69-17.89,0-24.72S363.09,252.28,374.78,259.1Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 78.2 143.61 79.11 175.02 60.98 173.49 60.06 142.08 78.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.49 60.06 143.61 77.31 143.61 46.02 173.49 28.78 173.49 60.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.91,22.88,140.72,44.35V84.11l37.19-21.47ZM175,61,143.61,79.11V46L175,27.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.02 60.98 173.49 60.06 173.49 28.78 175.02 27.89 175.02 60.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.91 22.88 176.35 21.99 139.17 43.46 140.72 44.35 177.91 22.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.17 43.46 140.72 44.35 140.72 84.11 139.17 83.22 139.17 43.46",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.32 59.13 144.78 75.03 144.78 67.08 151.66 51.17 155.95 55.15 154.41 61.82 163.92 41.48 172.32 51.17 172.32 59.13",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.69,43.5a4.51,4.51,0,0,0-2,3.52c0,1.3.91,1.83,2,1.18a4.49,4.49,0,0,0,2-3.53C157.73,43.37,156.82,42.85,155.69,43.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195 82.92 196.53 83.83 227.94 65.7 226.41 64.78 195 82.92",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.41 64.78 196.53 82.03 196.53 50.74 226.41 33.51 226.41 64.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,27.6,193.64,49.07V88.83l37.19-21.47Zm-2.89,38.1L196.53,83.83V50.74l31.41-18.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.94 65.7 226.41 64.78 226.41 33.51 227.94 32.61 227.94 65.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.83 27.6 229.27 26.71 192.09 48.18 193.64 49.07 230.83 27.6",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.09 48.18 193.64 49.07 193.64 88.83 192.09 87.94 192.09 48.18",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "225.24 63.85 197.7 79.75 197.7 71.8 204.58 55.9 208.87 59.87 207.33 66.54 216.84 46.2 225.24 55.9 225.24 63.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61,48.22a4.51,4.51,0,0,0-2,3.53c0,1.3.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.53C210.65,48.09,209.74,47.57,208.61,48.22Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.2,273.14c-10.31-10.64-16.36-39.2-6.31-47.64h51.16c10.06,8.44,4,37-6.29,47.63a4,4,0,0,1-.29.29l-.35.36c-.29.28-.6.56-.93.83l-.25.2c-.25.2-.5.4-.78.59a13,13,0,0,1-1.33.86c-8.48,5-22.23,5-30.71,0h0a15.13,15.13,0,0,1-1.34-.86c-.26-.18-.49-.37-.73-.56l-.3-.24a11.75,11.75,0,0,1-.9-.81l-.41-.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.61,222.1c11.67,6.82,11.67,17.87,0,24.69s-30.6,6.81-42.27,0-11.67-17.87,0-24.68S362.94,215.29,374.61,222.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,225.38c8.57,5,8.57,13.12,0,18.13s-22.47,5-31.05,0-8.57-13.12,0-18.13S360.42,220.38,369,225.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,234c8.58-5,22.47-5,31.05,0a14.38,14.38,0,0,1,5.13,4.77,14.36,14.36,0,0,1-5.13,4.76c-8.58,5-22.47,5-31.05,0a14.36,14.36,0,0,1-5.13-4.76A14.27,14.27,0,0,1,338,234Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.18,156.56l-13.77,14.2,14-8.81a41.42,41.42,0,0,1-.73,14.42,91.49,91.49,0,0,0-10.49,9.72l10.8-6s1.77,7.41.15,19.27c-.42,3.11-3,9.28-4.61,13.84a48.42,48.42,0,0,1-2.55,6.15l-.19.38q-4.2-1.72-8.69-3.27c-2.33-3.61-6-12.81-7.86-20.49-7.2-29.39,13.1-49.44,30.48-57.56C374.68,138.41,369.48,147,368.18,156.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.18,156.56l-13.77,14.2,14-8.81a41.42,41.42,0,0,1-.73,14.42,91.49,91.49,0,0,0-10.49,9.72l10.8-6s1.77,7.41.15,19.27c-.42,3.11-3,9.28-4.61,13.84a48.42,48.42,0,0,1-2.55,6.15l-.19.38q-4.2-1.72-8.69-3.27c-2.33-3.61-6-12.81-7.86-20.49-7.2-29.39,13.1-49.44,30.48-57.56C374.68,138.41,369.48,147,368.18,156.56Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.49,159.5c-2.72,3.56-4,8-4.87,12.29a60.81,60.81,0,0,0-1,13.26,56.31,56.31,0,0,0,6.66,25.47h0a.43.43,0,1,1-.76.41h0a57.11,57.11,0,0,1-6.33-25.88,61.29,61.29,0,0,1,1.26-13.31C351.34,167.41,352.71,163,355.49,159.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,168l0,0c.33.55,5.58,9.65,12.74,26.81l16,5.56-12.51,0,4.69,11.48,15.6,6.21-13-.18s1.33,13,9.47,19.71c4.49,3.72,6.65,4.17,8.61,3.43,2.4-.91,4.06-4.27,5.87-9.4s1.86-16.12-1.29-27.37a33,33,0,0,0-3.84-8.53C340.26,180.23,318.76,169.79,307.54,168Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.81,176.4c7.84,5.24,15,11.79,20.09,19.86a45.76,45.76,0,0,1,5.77,13,43.38,43.38,0,0,1,1.19,14.16s0,0-.05,0a0,0,0,0,1,0,0,56,56,0,0,0-2-13.91,51.44,51.44,0,0,0-5.51-12.88c-4.89-8-11.83-14.72-19.52-20.17,0,0,0,0,0-.06A.06.06,0,0,1,323.81,176.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.77,173.56h0a40,40,0,0,0-5,.22,79.73,79.73,0,0,0-19,4.62c-2.26.84-4.54,1.8-6.77,2.87-1.12.53-2.23,1.09-3.32,1.69a55,55,0,0,0-14.54,11,34.88,34.88,0,0,0-5,7c-.17.33-.37.65-.53,1h0c-.43.87-.81,1.72-1.16,2.56-4.19,9.48-4.55,16-4.28,23.34.2,5.66,2.12,12.13,3.22,13.19a2.54,2.54,0,0,0,.5.36c1.61,1,4.17.43,9-2.25,9.6-5.37,13.37-19,13.37-19L363,217.91l17.14-3.42,7-10.86-12.82-2.33,17.42-2.68c10.56-16.21,17.65-24.53,18.08-25l0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,173.78a79.73,79.73,0,0,0-19,4.62c-2.26.84-4.54,1.8-6.77,2.87-1.12.53-2.23,1.09-3.32,1.69a55,55,0,0,0-14.54,11,34.88,34.88,0,0,0-5,7c-.17.33-.37.65-.53,1h0c-.43.87-.81,1.72-1.16,2.56-4.19,9.48-4.55,16-4.28,23.34.2,5.66,2.12,12.13,3.22,13.19a2.54,2.54,0,0,0,.5.36,2.82,2.82,0,0,0,1.05.39c-1.18-8.77,3.13-31,9.66-40.15,6.8-9.51,22.92-23.31,45.07-28.07v0A41.38,41.38,0,0,0,404.81,173.78Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,241.8a75.15,75.15,0,0,1,1.26-19.39A62.61,62.61,0,0,1,362.65,204c3.28-5.72,8-10.4,13-14.54a72.56,72.56,0,0,1,16.71-10,0,0,0,0,1,.07,0,.07.07,0,0,1,0,.07,94.88,94.88,0,0,0-16.07,10.76,69.51,69.51,0,0,0-7.06,6.56,43,43,0,0,0-5.89,7.57,61.88,61.88,0,0,0-6.66,18.06,74.74,74.74,0,0,0-1.68,19.28.06.06,0,0,1-.05.06A.06.06,0,0,1,355,241.8Z",
    style: {
      fill: "#fff"
    }
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notification--inject-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.09,24.87c-1.57-.9-3.73-.77-6.12.6l-.68.4-32,18.44-.22.14A4.82,4.82,0,0,0,249.21,48a4.89,4.89,0,0,1-2.27,3.76l-38.07,22-.09,0a1.47,1.47,0,0,0-.62-1.3L206,71.23a1.51,1.51,0,0,0-1.51.16l-2.13,1.22L169.67,91.47a13.42,13.42,0,0,0-1.4,1l-.65.59a15.31,15.31,0,0,0-4.81,10.34V351.64c0,2.18.77,3.71,2,4.43l2.21,1.28c1.24.72,2.95.61,4.84-.49L288,289.81a15.18,15.18,0,0,0,6.86-11.89V31.76c0-2.76-1-4.69-2.54-5.6Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,355.92v.57l-.65.37c-1.89,1.1-3.6,1.2-4.84.49l-2.21-1.28c-1.24-.72-2-2.25-2-4.43V103.36A14.3,14.3,0,0,1,165.18,96l2.62,1.51a13.84,13.84,0,0,0-2.3,7.09V352.91a5.36,5.36,0,0,0,.94,3.31,2.93,2.93,0,0,0,2.36,1.1,5.85,5.85,0,0,0,2.83-.88Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,47.06a4,4,0,0,0-.8,2.22,4.88,4.88,0,0,1-.85,2.55l-2.63-1.52a4.33,4.33,0,0,0,.79-2.3,4.64,4.64,0,0,1,.86-2.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,357.43a2.9,2.9,0,0,1-2.36-1.1,5.27,5.27,0,0,1-.94-3.31V104.74a15,15,0,0,1,4.66-10l.21-.19c.14-.13.28-.26.43-.38a10.65,10.65,0,0,1,1.32-.9l32.66-18.87,2.13-1.22a1.47,1.47,0,0,1,.71-.23c.62,0,.69.72.69,1a1.75,1.75,0,0,0,1.69,2,2.71,2.71,0,0,0,1.32-.4l38.06-22a5.33,5.33,0,0,0,2.52-4.19,4.3,4.3,0,0,1,1.71-3.16.87.87,0,0,1,.18-.11l31.95-18.45.68-.4a7.5,7.5,0,0,1,3.62-1.11c2.67,0,4.33,2.19,4.33,5.71V278a14.63,14.63,0,0,1-6.62,11.47L171.46,356.55A5.74,5.74,0,0,1,168.64,357.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,26.54h0c2.4,0,3.84,1.95,3.84,5.22V277.92A14.31,14.31,0,0,1,287.51,289L171.38,356a5.31,5.31,0,0,1-2.58.81c-1.76,0-2.81-1.47-2.81-3.92V104.63A14.38,14.38,0,0,1,170.48,95l.22-.21.38-.34a11.61,11.61,0,0,1,1.28-.87L205,74.73l2.13-1.23a.92.92,0,0,1,.47-.16c.19,0,.2.49.2.54A2.22,2.22,0,0,0,210,76.33a3.1,3.1,0,0,0,1.56-.46l38.06-22a5.86,5.86,0,0,0,2.77-4.61,3.86,3.86,0,0,1,1.5-2.77l.14-.08L286,28l.68-.39A6.94,6.94,0,0,1,290,26.54m0-1a7.86,7.86,0,0,0-3.87,1.18l-.68.4-32,18.44a1.35,1.35,0,0,0-.22.14,4.8,4.8,0,0,0-1.91,3.56,4.9,4.9,0,0,1-2.27,3.77L211.07,75a2.14,2.14,0,0,1-1.07.34c-.72,0-1.21-.54-1.21-1.48s-.48-1.52-1.17-1.52a1.94,1.94,0,0,0-1,.29l-2.13,1.23L171.87,92.74a12,12,0,0,0-1.4,1l-.65.58A15.36,15.36,0,0,0,165,104.63V352.91c0,3.1,1.55,4.9,3.79,4.9a6.2,6.2,0,0,0,3.07-.95L288,289.81a15.18,15.18,0,0,0,6.86-11.89V31.76c0-3.92-2-6.2-4.82-6.2Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Gear--inject-5",
    d: "M286,50.24l-1.28-.06c-.09,0-.15-.13-.15-.28a7.39,7.39,0,0,0,0-1.07.7.7,0,0,1,.08-.44l1.26-1.79a.44.44,0,0,0,0-.39l-.63-1.36c-.06-.12-.17-.16-.24-.09l-1.41,1.49a.21.21,0,0,1-.28,0,2.12,2.12,0,0,0-.61-.37.28.28,0,0,1-.13-.31l.32-2c0-.14,0-.25-.13-.24l-1.49.18a.36.36,0,0,0-.23.25l-.61,2.11a.62.62,0,0,1-.22.31,5.93,5.93,0,0,0-.95.62c-.08.07-.2,0-.27-.08l-.69-1.06c-.07-.11-.18-.12-.25,0l-1.47,1.81a.48.48,0,0,0-.05.4l.44,1.38a.65.65,0,0,1,0,.44,12.21,12.21,0,0,0-.63,1.31.47.47,0,0,1-.24.26l-1.41.39a.38.38,0,0,0-.22.29l-.51,2.28c0,.13,0,.25.11.25l1.28.07c.09,0,.15.13.15.28a7.25,7.25,0,0,0,.05,1.06.85.85,0,0,1-.08.44l-1.27,1.79a.46.46,0,0,0,0,.4l.63,1.35c.06.13.17.17.24.09l1.4-1.48a.2.2,0,0,1,.28,0,2.28,2.28,0,0,0,.62.36.29.29,0,0,1,.12.32l-.31,2c0,.15,0,.25.12.24l1.49-.18a.34.34,0,0,0,.23-.25l.62-2.1a.58.58,0,0,1,.22-.31,6,6,0,0,0,1-.63c.08-.06.19,0,.26.08l.7,1.06c.07.11.18.13.25.05l1.47-1.81a.51.51,0,0,0,0-.41L283,55.47a.65.65,0,0,1,0-.44,10.51,10.51,0,0,0,.63-1.31.46.46,0,0,1,.25-.26l1.41-.39a.38.38,0,0,0,.21-.29l.52-2.28C286.09,50.36,286,50.25,286,50.24ZM282.44,52c-.47,2.08-1.95,3.9-3.31,4.06s-2.09-1.4-1.62-3.48,1.95-3.9,3.31-4.06S282.9,50,282.44,52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,133.52a1.06,1.06,0,0,1-.91-.52,1,1,0,0,1,.38-1.43L286.19,66a1.06,1.06,0,0,1,1.43.39,1,1,0,0,1-.38,1.43L173.68,133.38A1,1,0,0,1,173.16,133.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.42,116.14a1.16,1.16,0,0,1-.51-.12l-3.71-2a1.45,1.45,0,0,1-.67-.87,2.16,2.16,0,0,1,.27-1.64l3.71-6.33a1.06,1.06,0,0,1,1.44-.37,1,1,0,0,1,.37,1.43l-3.64,6.2,3.24,1.78a1.05,1.05,0,0,1,.42,1.42A1,1,0,0,1,179.42,116.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.06,98.84,184.81,151c-3.38,2-6.13-.12-6.13-4.64h0c0-4.51,2.75-9.75,6.13-11.71l90.25-52.1c3.38-2,6.13.12,6.13,4.63h0C281.19,91.65,278.44,96.89,275.06,98.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,93.13l-1.25-.54a8.67,8.67,0,0,0,.38-2.44c0-2.89-1.76-4.22-3.93-3S268,91.8,268,94.69s1.76,4.22,3.93,3a7.57,7.57,0,0,0,2.58-2.8l1.25.54a.5.5,0,0,0,.48-.06,1.58,1.58,0,0,0,.64-.79C277.1,93.92,277,93.29,276.68,93.13Zm-4.8,2.38c-1.28.74-2.32,0-2.32-1.75a5.54,5.54,0,0,1,2.32-4.43c1.28-.74,2.32,0,2.32,1.75A5.54,5.54,0,0,1,271.88,95.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,93.13l-1.25-.54a8.67,8.67,0,0,0,.38-2.44c0-2.89-1.76-4.22-3.93-3S268,91.8,268,94.69s1.76,4.22,3.93,3a7.57,7.57,0,0,0,2.58-2.8l1.25.54a.5.5,0,0,0,.48-.06,1.58,1.58,0,0,0,.64-.79C277.1,93.92,277,93.29,276.68,93.13Zm-4.8,2.38c-1.28.74-2.32,0-2.32-1.75a5.54,5.54,0,0,1,2.32-4.43c1.28-.74,2.32,0,2.32,1.75A5.54,5.54,0,0,1,271.88,95.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,167.58a1.05,1.05,0,0,1-.53-2l113.56-65.56a1.05,1.05,0,0,1,1.05,1.82L173.68,167.44A1,1,0,0,1,173.16,167.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.68,175.8a31.25,31.25,0,0,1-4.42,15c-.43.76-.9,1.5-1.38,2.23s-1,1.42-1.52,2.09-1,1.18-1.44,1.74q-.36.4-.72.78a26.41,26.41,0,0,1-5.82,4.69,17.82,17.82,0,0,1-3.19,1.46c-.36.12-.71.22-1.06.3a9.2,9.2,0,0,1-5.46-.17c-3.42-1.26-5.59-4.92-5.6-10.42,0-9.76,6.85-21.63,15.31-26.51S201.68,166,201.68,175.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,165.72h0c4.7,0,7.62,3.86,7.62,10.08a30.15,30.15,0,0,1-4.31,14.55c-.41.73-.87,1.47-1.34,2.17s-1,1.39-1.49,2-.94,1.18-1.41,1.7c-.23.26-.46.52-.69.76a25.73,25.73,0,0,1-5.64,4.54,16.64,16.64,0,0,1-3,1.39c-.34.11-.67.2-1,.28a10.22,10.22,0,0,1-2.39.3,7.42,7.42,0,0,1-2.57-.44c-3.21-1.19-5.05-4.7-5.05-9.63,0-9.48,6.67-21,14.88-25.77a13.12,13.12,0,0,1,6.41-2m0-.85a13.92,13.92,0,0,0-6.83,2.09c-8.46,4.88-15.31,16.75-15.31,26.51,0,5.5,2.18,9.16,5.6,10.42a8.12,8.12,0,0,0,2.87.5,11,11,0,0,0,2.59-.33c.35-.08.7-.18,1.06-.3a17.82,17.82,0,0,0,3.19-1.46,26.41,26.41,0,0,0,5.82-4.69q.36-.37.72-.78.74-.84,1.44-1.74c.53-.67,1-1.37,1.52-2.09s1-1.47,1.38-2.23a31.25,31.25,0,0,0,4.42-15c0-6.92-3.45-10.93-8.47-10.93Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.63,151.45l-34.85,20.12c-1.49.86-2.7,0-2.7-2h0a6.46,6.46,0,0,1,2.7-5.15l34.85-20.12c1.49-.86,2.7.05,2.7,2h0A6.46,6.46,0,0,1,242.63,151.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,170.53l-18.5,10.68c-.79.46-1.43,0-1.43-1.08h0a3.42,3.42,0,0,1,1.43-2.73L225,166.72c.79-.46,1.43,0,1.43,1.08h0A3.43,3.43,0,0,1,225,170.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.86,142.2c-.16-1.79-1.35-2.52-2.76-1.7l-1.69,1a6.62,6.62,0,0,0-2.76,4.89l-.07.85a13.28,13.28,0,0,0,7.34-4.24Zm-3.61-2.08a4.66,4.66,0,0,0,1.95-3.73c0-1.44-.87-2.1-1.95-1.47a4.66,4.66,0,0,0-1.95,3.73C261.3,140.08,262.17,140.74,263.25,140.12Zm-2.92.75c0-.19-.12-.28-.27-.2l-1.05.61v-1.4c0-.2-.12-.28-.27-.2a.64.64,0,0,0-.26.51v1.4l-1.05.6a.64.64,0,0,0-.27.51c0,.19.12.28.27.2l1.05-.61v1.4c0,.2.12.29.26.2a.62.62,0,0,0,.27-.5V142l1.05-.61A.62.62,0,0,0,260.33,140.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.51,132.27c.08,0,.14-.05.18,0a.65.65,0,0,1,.1.19l1.78,5.09v.07a.54.54,0,0,1-.05.21.38.38,0,0,1-.14.16l-.53.3c-.09.06-.16.07-.2,0a.25.25,0,0,1-.08-.12l-.31-.89-2.3,1.32-.31,1.26a.8.8,0,0,1-.08.21.46.46,0,0,1-.2.19l-.52.31a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15.15.15,0,0,1,0-.07l1.78-7.15a1.16,1.16,0,0,1,.1-.3.52.52,0,0,1,.17-.19Zm.4,4-.8-2.3-.8,3.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.58,131.57a1.19,1.19,0,0,1,.4-.17.72.72,0,0,1,.31,0,.52.52,0,0,1,.23.06.44.44,0,0,1,.15.1v-2.07a.42.42,0,0,1,.06-.21.38.38,0,0,1,.14-.16l.55-.32a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v6.35a.49.49,0,0,1-.06.22.45.45,0,0,1-.14.16l-.55.31a.11.11,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-.23a2,2,0,0,1-.15.28,2.79,2.79,0,0,1-.23.32,3.13,3.13,0,0,1-.31.33,3.17,3.17,0,0,1-.4.29,1.22,1.22,0,0,1-.66.19.77.77,0,0,1-.5-.22,1.27,1.27,0,0,1-.33-.53,2.65,2.65,0,0,1-.13-.78c0-.1,0-.21,0-.34s0-.24,0-.34a4.43,4.43,0,0,1,.13-.93,4.79,4.79,0,0,1,.33-.92,3.78,3.78,0,0,1,.5-.79A2.36,2.36,0,0,1,275.58,131.57Zm-.68,2.73a4.86,4.86,0,0,0,0,.54c0,.41.13.65.29.74a.6.6,0,0,0,.61-.07,1.72,1.72,0,0,0,.59-.63,2,2,0,0,0,.28-1,3.79,3.79,0,0,0,0-.38,3.21,3.21,0,0,0,0-.36.73.73,0,0,0-.28-.63.54.54,0,0,0-.59.06,1.65,1.65,0,0,0-.61.62A2.5,2.5,0,0,0,274.9,134.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.07,129a1.89,1.89,0,0,1,.41-.17,1.2,1.2,0,0,1,.31,0,.77.77,0,0,1,.23.06l.15.1v-2.06a.49.49,0,0,1,.06-.22.44.44,0,0,1,.14-.16l.55-.31a.12.12,0,0,1,.13,0,.18.18,0,0,1,.06.15v6.36a.42.42,0,0,1-.06.21.31.31,0,0,1-.13.16l-.55.32a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15V133l-.15.27a3.29,3.29,0,0,1-.23.33c-.09.11-.2.21-.31.32a2,2,0,0,1-.41.29,1.11,1.11,0,0,1-.65.19.78.78,0,0,1-.51-.21,1.41,1.41,0,0,1-.32-.54,2.64,2.64,0,0,1-.14-.78v-.68a4.46,4.46,0,0,1,.14-.93,5.14,5.14,0,0,1,.32-.91,3.89,3.89,0,0,1,.51-.8A2.32,2.32,0,0,1,280.07,129Zm-.67,2.74a2.44,2.44,0,0,0,0,.54c0,.4.12.65.29.74a.61.61,0,0,0,.6-.07,1.66,1.66,0,0,0,.6-.63,2.29,2.29,0,0,0,.28-1c0-.1,0-.22,0-.37s0-.27,0-.36a.82.82,0,0,0-.28-.64.56.56,0,0,0-.6.06,1.7,1.7,0,0,0-.6.62A2.38,2.38,0,0,0,279.4,131.71Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,219.92a1.05,1.05,0,0,1-.53-2L286.19,152.4a1,1,0,0,1,1.43.38,1.06,1.06,0,0,1-.38,1.44L173.68,219.78A1.07,1.07,0,0,1,173.16,219.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.68,228.92a31.18,31.18,0,0,1-4.42,15c-.43.76-.9,1.51-1.38,2.23s-1,1.42-1.52,2.1-1,1.18-1.44,1.74l-.72.78a26.41,26.41,0,0,1-5.82,4.69,17.74,17.74,0,0,1-3.19,1.45c-.36.12-.71.22-1.06.3a9.21,9.21,0,0,1-5.46-.16c-3.42-1.27-5.59-4.93-5.6-10.43,0-9.76,6.85-21.62,15.31-26.5S201.68,219.16,201.68,228.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.9,233.8a13.73,13.73,0,0,0,.06,5.38,20.74,20.74,0,0,1,.43,5.38c0,.35-.08.77.2,1a.7.7,0,0,0,.88-.08,2.18,2.18,0,0,0,.49-.83c.11,1.29.22,2.59.32,3.88a2.3,2.3,0,0,0,.37,1.26,1.84,1.84,0,0,0,2,.34,5.49,5.49,0,0,0,3.34-3.66,10.6,10.6,0,0,0,.12-5.1,21.09,21.09,0,0,0-2.37-6.58,19.76,19.76,0,0,1-1.76-3.38,3.78,3.78,0,0,0-.6-1.34c-.16-.2-.31-.14-.53,0a5.71,5.71,0,0,0-.6.31,4.75,4.75,0,0,0-1,.88,5.23,5.23,0,0,0-.78,1.14,5.9,5.9,0,0,0-.51,1.28A1,1,0,0,0,177.9,233.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.26,243.89c-.43.76-.9,1.51-1.38,2.23s-1,1.42-1.52,2.1l-1.46-4.54A6.36,6.36,0,0,1,197.26,243.89Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.79,245.5c-.49.72-1,1.42-1.52,2.1s-1,1.18-1.44,1.74l-.72.78a26.19,26.19,0,0,1-5.82,4.69,18.21,18.21,0,0,1-3.19,1.46l-1.06.3a17.6,17.6,0,0,0-1.64-7.22l3.69-2,.08,0c1.93-1.33,3.23-1.09,6.78-2.61.06,0-.43-.28-.37-.31l2.32-.7h0A25.66,25.66,0,0,1,195.79,245.5Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184,243.27c-.29-1.08-1.63-1.86-2.89-3.74s-2.9-6.08-.32-8.05c-.47-2.52,1.55-5.62,4.31-6.86,3.63-1.63,7.87-1.41,10.33,1.7a5.67,5.67,0,0,1-.1,7.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.94,239.28a4.91,4.91,0,0,1-1.07,2.12,6.12,6.12,0,0,1-2.92,1.65l0,1,0,.62,0,.66,0,1.12s1.73,2,1.86,3.53l-.72.78a16.62,16.62,0,0,1-8-2.61V248l-.08-1.64-.18-4,0-1.12a1,1,0,0,1-.18.42,1.64,1.64,0,0,1-.6.49,1.66,1.66,0,0,1-1.45.08l-.11,0a.55.55,0,0,1-.15-.08l-.12-.07-.1-.07h0l-.1-.08a2.88,2.88,0,0,1-.86-3.34c.35-.84,1.31-1.59,2-1.31s.82.74,1.14,1.26,1.79-1.06.77-3.72a4.81,4.81,0,0,0,1.47-4.27c.53-1.93,4.12-2.17,4.75-1.44.52-1.22.46-2,1.48-1.64s2.72,1,3.32,5.2A17.49,17.49,0,0,1,194.94,239.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.62,238.88l2.14.06a1.41,1.41,0,0,1-1.4,1.24C188.77,240.14,188.52,239.59,188.62,238.88Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,240.05a.92.92,0,0,0-1.25-.76l-.1.05a.81.81,0,0,0,.75.84A1.06,1.06,0,0,0,190,240.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.61 233.25 191.1 237.43 193.1 236.07 190.61 233.25",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,233.45a.55.55,0,0,0,.68.59.92.92,0,0,0,.69-.87.55.55,0,0,0-.67-.59A.94.94,0,0,0,192.78,233.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.82,235.13a.56.56,0,0,0,.68.59.93.93,0,0,0,.7-.87.56.56,0,0,0-.68-.59A.94.94,0,0,0,187.82,235.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,243.05a9.52,9.52,0,0,1-4.27-.2,4.2,4.2,0,0,1-2-1.66s-.15,1.35,1.87,2.3A11.43,11.43,0,0,0,191,244Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,231.39l-1.53.09a1.25,1.25,0,0,1,1-.9C194,230.56,194.21,230.92,194.08,231.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,232.74l-1.67,1.11a1.18,1.18,0,0,1,.57-1.25C188.38,232.29,188.87,232.36,189,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,227.23c.3,1.66-1.64,5.51-4.23,7.26s-4.27,1.41-4.27,1.41-.3-5.31,2.28-7.31S191.86,227.23,191.86,227.23Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.19,256.88c-.36.12-.71.22-1.06.3a9.21,9.21,0,0,1-5.46-.16,5.75,5.75,0,0,1-1.69-1.34c1.87-4.44,2.87-5.28,5.42-6.33h0C182.13,250.62,182.9,254.93,183.19,256.88Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,218.84h0c4.7,0,7.62,3.86,7.62,10.08a30.22,30.22,0,0,1-4.31,14.56c-.41.73-.87,1.46-1.34,2.17s-1,1.39-1.49,2-.94,1.18-1.41,1.7c-.22.25-.46.51-.69.75a25.16,25.16,0,0,1-5.64,4.54,16,16,0,0,1-3,1.39c-.34.11-.67.21-1,.28a10.25,10.25,0,0,1-2.39.31,7.19,7.19,0,0,1-2.57-.45c-3.21-1.18-5.05-4.69-5.05-9.63,0-9.47,6.67-21,14.88-25.77a13.23,13.23,0,0,1,6.41-2m0-.84a13.82,13.82,0,0,0-6.83,2.09c-8.46,4.88-15.31,16.74-15.31,26.5,0,5.5,2.18,9.16,5.6,10.43a8.35,8.35,0,0,0,2.87.49,11,11,0,0,0,2.59-.33c.35-.08.7-.18,1.06-.3a17.74,17.74,0,0,0,3.19-1.45,26.41,26.41,0,0,0,5.82-4.69l.72-.78q.74-.84,1.44-1.74c.53-.68,1-1.38,1.52-2.1s1-1.47,1.38-2.23a31.18,31.18,0,0,0,4.42-15c0-6.92-3.45-10.92-8.47-10.92Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.63,203.78l-34.85,20.13c-1.49.85-2.7-.06-2.7-2h0a6.45,6.45,0,0,1,2.7-5.15l34.85-20.12c1.49-.86,2.7.05,2.7,2h0A6.45,6.45,0,0,1,242.63,203.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,222.87l-18.5,10.68c-.79.45-1.43,0-1.43-1.09h0a3.43,3.43,0,0,1,1.43-2.73L225,219.05c.79-.45,1.43,0,1.43,1.08h0A3.43,3.43,0,0,1,225,222.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,272.25a1,1,0,0,1-.53-1.95l113.56-65.56a1,1,0,1,1,1.05,1.81L173.68,272.11A1,1,0,0,1,173.16,272.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.68,281.18a31.18,31.18,0,0,1-4.42,15c-.43.76-.9,1.51-1.38,2.23s-1,1.42-1.52,2.1-1,1.18-1.44,1.73q-.36.41-.72.78a26.41,26.41,0,0,1-5.82,4.69,17.14,17.14,0,0,1-3.19,1.46c-.36.12-.71.22-1.06.3a9.12,9.12,0,0,1-5.46-.17c-3.42-1.26-5.59-4.92-5.6-10.42,0-9.76,6.85-21.62,15.31-26.5S201.68,271.42,201.68,281.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.6,299.32c-.22.32-.43.65-.66,1s-.55.78-.82,1.17l-1.45-4.51c3-.92,3.58-.53,4.44-.16-.29.58-1,1.77-1.44,2.42Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,300.29c-.28.39-.55.77-.84,1.16,0,0,0,.05-.05.08-.48.64-1,1.25-1.47,1.85l-.72.83-.55.6h0a24.23,24.23,0,0,1-3.93,2.86,18.29,18.29,0,0,1-3.19,1.47c-.36.11-.71.21-1.06.29a11.22,11.22,0,0,1-1.46.26,9,9,0,0,1-2.65-.06,2.62,2.62,0,0,0,0-.28c-.29-6.12,1.82-7.7,1.85-7.71s.87-.42,1.37-.64c1-.46,8.13-1.77,8.13-1.77l2.31-2.3a7.68,7.68,0,0,1,3.26,1.85S194.48,299.49,194,300.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.89,297.9c-1.69,1.86-5.85,1.45-6.27-1.3,0-.91.65-1.78.48-2.68s-1.12-1.44-1.57-2.24a2.27,2.27,0,0,1,.13-2.37c.49-.68,1.37-1.12,1.51-1.94s-.57-1.86-.13-2.78a4.29,4.29,0,0,1,2.69-2.48c1.26-3.44,4.19-6.54,8-6.95,4.22-.64,8.92,2.82,8.25,7.33-.19,1.26-1.25,2.48-.73,3.78.67,1.13,2.16,2.16,1,3.58-.41.52-1.1.8-1.39,1.39a6.26,6.26,0,0,0-.22,1.85c-.2.93-.65,2.13-1.54,2.46s-2,0-2.77.28-.61,1-2.74,1.11c-1.12.08-1.84-.46-3-.15A9.41,9.41,0,0,0,183.89,297.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75,298.62l-.55-4.53a1.89,1.89,0,0,1-2.38.25,2.83,2.83,0,0,1-1-3.76,2,2,0,0,1,3.33-.38c1.16-.07,1.52-1.93.54-3.42,0,0-.46-3.2,1.64-4.59,1.6-1.05,2.7-.6,4.5-.57,1.31-.47,1.44-2.36,3.12-2.09a5.94,5.94,0,0,1,1.44,5,9.36,9.36,0,0,0,.42,1.88c.67,3-.46,6.44-1.71,7.45a7.38,7.38,0,0,1-3.13,1.58l.14,1.26h0c.06.63.21.61.74.47l.79-.2s1.07,1.64-2.68,3.36c-5.59,2.56-7.76.71-7.76.71l1.29-.6A1.73,1.73,0,0,0,183.75,298.62Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,291.22l2.07,0a1.41,1.41,0,0,1-1.28,1.18C188.52,292.44,188.16,291.89,188.3,291.22Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,291.68a.91.91,0,0,1,1.23.59,1,1,0,0,1-.6.18.83.83,0,0,1-.79-.7A.46.46,0,0,1,188.46,291.68Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.22,282.75l-1.55-.23a1,1,0,0,1,1-.8A.76.76,0,0,1,193.22,282.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.49,285.57l1.41-1.3a.7.7,0,0,0-1.12,0A1.11,1.11,0,0,0,186.49,285.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.15,285.4a.56.56,0,0,0,.68.59.94.94,0,0,0,.7-.87.56.56,0,0,0-.68-.59A.94.94,0,0,0,192.15,285.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,287.51a.55.55,0,0,0,.67.59.94.94,0,0,0,.7-.87.55.55,0,0,0-.68-.59A.92.92,0,0,0,187.22,287.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,295.41c-2.62.53-5.17.42-5.83-.65,0,0,.07,1.37,1.17,1.69a15,15,0,0,0,4.76-.09Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.75,289.46a1.93,1.93,0,0,1,.82.22l1.7-1.39.09-.07.16.11a.57.57,0,0,1,.13.2,7.42,7.42,0,0,0,.56,1.53,1.22,1.22,0,0,0,.49.42l.23.08.14,0a1.82,1.82,0,0,0,.4,0h.06l.11,0,.11,0a1.9,1.9,0,0,0,.34-.11l.14-.05.19-.08a3.94,3.94,0,0,0,2.23-2.37c.3-.81.13-1.69.78-2l.06,0,.06,0c.48-.11.5.76.84,1.23a1.5,1.5,0,0,0,.52.45l.12.06.06,0h.06l.06,0h.15a1.94,1.94,0,0,0,.57-.05H193a3.94,3.94,0,0,0,.69-.25,3.45,3.45,0,0,0,1.19-.86,3.2,3.2,0,0,0,.69-1.26,12.49,12.49,0,0,0,.26-1.9,1.1,1.1,0,0,1,.1-.29,1.7,1.7,0,0,0,.25-.77c0-.28-.22-.45-.4-.39l-.32.11c-.34.13-.71.27-1.08.43a10.41,10.41,0,0,0-2.11,1.16,16.93,16.93,0,0,1-1.89,1.53,11.1,11.1,0,0,1-2.13.33,13.93,13.93,0,0,0-3.42,1.49l-.35.2-.39.34Zm9.86-4.52a4.81,4.81,0,0,1,1.65-1.47c.17-.1.33-.19.48-.26l.06,0s0,0,.06,0l.17-.07.06,0,.07,0,.14,0,.13,0a.35.35,0,0,1,.11,0h.18l.07,0h.13a.64.64,0,0,1,.27,0c.24.1.19,1.05.13,1.55a3.37,3.37,0,0,1-.57,1.58,2.36,2.36,0,0,1-.3.34,2.83,2.83,0,0,1-.77.53c-.82.39-1.32.28-1.61,0h0l0,0,0,0,0,0,0,0-.05-.07,0,0v0l0,0v0a1.45,1.45,0,0,1-.13-.29A2,2,0,0,1,191.61,284.94Zm-6.4,2.58a4.16,4.16,0,0,1,1.9-1.2l.11-.05.48-.14.19,0a4.8,4.8,0,0,1,.48-.08h.39a.69.69,0,0,1,.34.09c.23.18.21.8.14,1.36a2.87,2.87,0,0,1-.42,1.14,3.3,3.3,0,0,1-1.48,1.23c-.77.34-1.23.25-1.53,0l-.05,0,0-.05,0,0,0,0,0,0,0,0s0,0,0-.06l-.09-.16a.31.31,0,0,0-.05-.1l-.06-.16v-.06C185.18,288.67,185,287.84,185.21,287.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.74,288l-2.19,1.48-.69-2.56c.08-.46.18-.85.57-1l.06,0,.06,0h0Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.67,309.7a9,9,0,0,1-2.65-.06,7.59,7.59,0,0,1-1.34-.37,7,7,0,0,1-1.9-1c1.86-5,2.17-5.42,5.08-6.58h0C182.23,303.92,181.11,308.26,180.67,309.7Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,271.1h0c4.7,0,7.62,3.86,7.62,10.08a30.22,30.22,0,0,1-4.31,14.56c-.41.73-.87,1.46-1.34,2.17s-1,1.39-1.49,2-.94,1.17-1.41,1.69c-.23.26-.46.52-.69.76A25.16,25.16,0,0,1,186,307a16,16,0,0,1-3,1.39c-.34.11-.67.21-1,.28a10.25,10.25,0,0,1-2.39.31,7.19,7.19,0,0,1-2.57-.45c-3.21-1.18-5.05-4.7-5.05-9.63,0-9.47,6.67-21,14.88-25.77a13.23,13.23,0,0,1,6.41-2m0-.84a13.82,13.82,0,0,0-6.83,2.09c-8.46,4.88-15.31,16.74-15.31,26.5,0,5.5,2.18,9.16,5.6,10.42a8.12,8.12,0,0,0,2.87.5,11,11,0,0,0,2.59-.33c.35-.08.7-.18,1.06-.3a17.14,17.14,0,0,0,3.19-1.46A26.41,26.41,0,0,0,192.2,303q.36-.37.72-.78c.49-.55,1-1.13,1.44-1.73s1-1.38,1.52-2.1,1-1.47,1.38-2.23a31.18,31.18,0,0,0,4.42-15c0-6.92-3.45-10.92-8.47-10.92Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.63,256.12l-34.85,20.12c-1.49.86-2.7-.05-2.7-2h0a6.46,6.46,0,0,1,2.7-5.15l34.85-20.12c1.49-.86,2.7,0,2.7,2h0A6.46,6.46,0,0,1,242.63,256.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,275.2l-18.5,10.68c-.79.46-1.43,0-1.43-1.08h0a3.42,3.42,0,0,1,1.43-2.73L225,271.39c.79-.46,1.43,0,1.43,1.08h0A3.42,3.42,0,0,1,225,275.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,324.59a1.05,1.05,0,0,1-.53-2l113.56-65.56a1.05,1.05,0,0,1,1.05,1.82L173.68,324.45A1.07,1.07,0,0,1,173.16,324.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.81,305.46a4.5,4.5,0,0,1-1.87,3.58c-1,.6-1.88,0-1.88-1.42a4.48,4.48,0,0,1,1.88-3.58C231,303.45,231.81,304.08,231.81,305.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.05,299.55a4.5,4.5,0,0,1-1.87,3.58c-1,.6-1.88,0-1.88-1.42a4.48,4.48,0,0,1,1.88-3.58C241.21,297.53,242.05,298.17,242.05,299.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82,313.54c0,1.38.84,2,1.88,1.41a4.5,4.5,0,0,0,1.87-3.58c0-1.38-.84-2-1.87-1.42A4.5,4.5,0,0,0,217.82,313.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.57,59.1l-10.35-6h0c-6.35-3.58-15.07-3-24.71,2.54-19.4,11.2-35.13,38.45-35.13,60.86,0,11.18,3.92,19,10.26,22.72h0L58,145.18c6.4,4.07,15.43,3.7,25.45-2.08,19.4-11.2,35.13-38.45,35.13-60.86C118.62,70.6,114.37,62.57,107.57,59.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.71,104.69a56.56,56.56,0,0,0-1.33,11.81c0,11.18,3.92,19,10.26,22.72h0l10.4,6,3.11-5.2,8.72-17.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.79,146.7c-11.25,0-18.25-9.15-18.25-23.89C49.54,100.82,65,74,84.09,63c5.33-3.07,10.41-4.64,15.09-4.64a16.18,16.18,0,0,1,13.11,6.14c3.36,4.21,5.14,10.35,5.14,17.75,0,22-15.5,48.83-34.54,59.83-5.33,3.07-10.41,4.63-15.1,4.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.18,59.55a15,15,0,0,1,12.18,5.68c3.19,4,4.87,9.88,4.87,17,0,21.61-15.22,48-33.94,58.79-5.07,2.93-10.09,4.48-14.5,4.48a15,15,0,0,1-12.17-5.68c-3.19-4-4.88-9.88-4.88-17,0-21.62,15.23-48,33.94-58.79,5.08-2.93,10.09-4.48,14.5-4.48m0-2.39c-4.72,0-10.05,1.54-15.69,4.8-19.41,11.2-35.14,38.45-35.14,60.86,0,15.89,7.92,25.08,19.44,25.08,4.73,0,10.06-1.54,15.7-4.8,19.4-11.2,35.13-38.45,35.13-60.86,0-15.89-7.91-25.08-19.44-25.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.48,100.31c5.23-3,9.48-11.13,9.48-18.12S88.71,72,83.48,75,74,86.16,74,93.14,78.24,103.34,83.48,100.31ZM101,110.4c-.77-8.66-6.54-12.21-13.41-8.25l-8.2,4.74c-6.88,4-12.65,14.18-13.42,23.73l-.26,5.73a11.19,11.19,0,0,0,4.29.8,22.91,22.91,0,0,0,11.09-3.49c7.78-4.49,15-12.55,20-21.68Z",
    style: {
      fill: "#1473E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plus--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.76,126.73l-5-2.88h0l0,0h0c-2.41-1.36-5.72-1.16-9.38,1C46,129,40,139.4,40,147.91c0,4.25,1.49,7.24,3.9,8.64h0l5,2.88c2.44,1.55,5.87,1.41,9.67-.79C66,154.39,72,144,72,135.52,72,131.1,70.35,128.05,67.76,126.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.51,143.43a21.88,21.88,0,0,0-.5,4.48c0,4.25,1.49,7.24,3.9,8.64h0l5,2.89,1.18-2,3.31-6.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.62,127.82c-7.38,4.25-13.36,14.61-13.36,23.12s6,12,13.35,7.71S72,144,72,135.52,66,123.56,58.62,127.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.52,138.67c0-1.18-.71-1.72-1.6-1.21l-4.71,2.72V133.9c0-1.18-.71-1.72-1.6-1.21A3.83,3.83,0,0,0,57,135.74V142l-4.71,2.73a3.8,3.8,0,0,0-1.6,3.05c0,1.17.71,1.71,1.6,1.2L57,146.28v6.29c0,1.17.71,1.71,1.59,1.2a3.8,3.8,0,0,0,1.6-3.05v-6.28l4.71-2.72A3.81,3.81,0,0,0,66.52,138.67Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.88,335.43c-.93-12.83.51-22.66-.56-42.7h0c-.1-5.13-.28-10.64-.63-15.52-1.16-16.45-3.69-22.07-3.93-25.24,0,0,.25-28.42-.82-64.4-.51-16.93-5.41-22.06-9.33-31H382c-5.2,22.17-6.68,70.52-6.53,93.37.08,11.65,1,58.09.66,63.4-.28,5.09-.42,9.16-2.41,11.3-4.18,4.48-10.84,10.4-17.27,13.95.76,2,11.22,2.89,14.34,1.37,5-2.43,12.95-8.63,14.7-9.8,8.5-5.66,6.25-13.16,6.25-13.16v-.54c.08-2.83,8.05-35.7,9.22-45.32,1.2-9.91-.83-23.62-.83-23.62l6.49-30.59s2.63,23.65,6,37.87c2.73,11.57,7.22,31.32,10.29,45.57h0c2.94,16.41,6.09,27.86,6.84,36.07.23,2,3.62,21.44,4.54,25.85s10.52,4.53,11.14-3.06C445.82,354.14,444.05,337.85,443.88,335.43Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89,344.32c.58.66.32,3.82,1.92,5.07,1.83,1.44,7.12,3.68,13.87,2.4s10.32-3.63,12.92-6.1,6.23-5.95,9.27-6.81c2.82-.81,5.85-2.3,6.71-3.25s-.33-5.59-.33-5.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.75,316.42a1.08,1.08,0,0,1,1.07.87c.27,1.09.48,3.33,1,5.11a33.07,33.07,0,0,1,1.2,9.67c-.26,2.07-4.84,3.76-7.76,5.08a38,38,0,0,0-9.3,6.74c-3.05,2.86-9.63,5.93-14.06,6.25-6.76.48-11.24-1.14-12.73-3.54-1.84-3-1.48-5.46,6.09-9.57,1.44-.78,6.44-4.18,8.14-5.41a40,40,0,0,0,5.07-4.3,30.1,30.1,0,0,0,2.25-2.53,11,11,0,0,0,1.83-2.67c.07-.21.12-.46.19-.68a12.35,12.35,0,0,0,.4-1.88c.09-.67.12-1.63.71-2.06s4.35-.22,5.35-.05,3.78.69,4.52,1.75a5.9,5.9,0,0,1,.79,2.83c0,.46.06.93.09,1.39,0,.2-.05.56.22.46s.5-.8.59-1c.19-.53.3-1.09.5-1.61a8,8,0,0,1,.88-1.73,7.51,7.51,0,0,1,1.16-1.35c.4-.36,1.06-.66,1.78-1.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.07,337.71c9.84.13,14.11,6.76,14.74,10.55a23.06,23.06,0,0,1-6.88,1.88c-6.76.48-11.52-1.12-13-3.52C349.18,343.82,349.27,340.78,356.07,337.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.62,337.63a.49.49,0,0,0,.33-.82c-1.46-1.62-6.37-4.3-9.91-3.7a.49.49,0,0,0,.15,1c3.31-.54,7.89,2.11,9.05,3.4A.47.47,0,0,0,371.62,337.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.7,334.89a.51.51,0,0,0,.3-.13.5.5,0,0,0,0-.69c-1.46-1.62-6.37-4.3-9.91-3.7a.48.48,0,0,0-.39.56.47.47,0,0,0,.55.4c3.3-.55,7.89,2.11,9,3.4A.47.47,0,0,0,375.7,334.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.45,331.81a.43.43,0,0,0,.3-.13.48.48,0,0,0,0-.68c-1.46-1.63-6.38-4.3-9.9-3.71a.49.49,0,0,0-.4.56.48.48,0,0,0,.55.41c3.3-.55,7.89,2.11,9,3.39A.46.46,0,0,0,379.45,331.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.13,328.74a.53.53,0,0,0,.29-.12.49.49,0,0,0,0-.69c-2-2.31-7.19-4.3-10.72-3.71a.49.49,0,0,0-.4.56.47.47,0,0,0,.55.4c3.18-.53,8.07,1.35,9.85,3.4A.49.49,0,0,0,383.13,328.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.25,365.69c.25,4.39.94,7.3,2.5,9.88s4.5,3.39,7.48,2.63,6.79-2.77,7.65-6.56,1.35-6.39.67-10.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.77,333.86c1.23.1,1.59,6,2.3,11.91.76,6.33,2.65,9,3.33,14.14.77,5.93-.21,8.58-2.29,12.17s-9.43,7.11-13.06,2c-3-4.19-2.94-8.83-3.17-14.75-.28-7.15-.12-9.65-.79-14.26-.93-6.42-1.59-9.7-.52-10.19l.59,4.28c.13.33.4.68.51.14a3.38,3.38,0,0,0,0-1.1c-.18-1.64.65-1.77,1.09-1.9,1-.27,5.95-.52,6.87-.58s4.17-.2,4.59.33a3.52,3.52,0,0,1,.41,1.72c.11.89.32,1.54.34,1.26.06-.64-.06-2.3-.08-2.7s-.08-.91-.08-1.3S443.8,334.24,443.77,333.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.74,363.35a14.77,14.77,0,0,1-2.3,9c-2.08,3.59-10,7.12-13.65,2-1.81-2.55-2.29-5.57-2.54-8.66C433.42,361.72,446.31,360,449.74,363.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.93,359.23a.42.42,0,0,0,.15,0c.05,0,5.73-2.37,11.26-1.09a.46.46,0,0,0,.54-.34.45.45,0,0,0-.34-.55,21.37,21.37,0,0,0-11.85,1.16.46.46,0,0,0-.22.61A.47.47,0,0,0,433.93,359.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.06,353.68a.46.46,0,0,0,.1-.89c-5.5-1.86-11.61.94-11.84,1.06a.45.45,0,0,0-.19.61.47.47,0,0,0,.62.19c.05,0,6-2.73,11.12-1A.62.62,0,0,0,445.06,353.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.87,349.51a.46.46,0,0,0,.38-.3.45.45,0,0,0-.27-.58c-6.06-2.17-11.85.89-12.07,1a.45.45,0,0,0-.15.62.46.46,0,0,0,.63.16s5.65-3,11.28-.95A.35.35,0,0,0,444.87,349.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.57,345.4a.45.45,0,0,0,.11-.87c-5.67-2.13-11.91,1-12.14,1.14a.45.45,0,0,0-.17.62.45.45,0,0,0,.62.17c.06,0,6.11-3.06,11.37-1.08A.5.5,0,0,0,444.57,345.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.86,156.68c5.51,10.06,9.61,18.29,10.17,48.21s-.22,41.14-.1,44.75,2.22,10.06,4.06,27.83-.33,39-.33,39-1.28,2.86-8.07,3.47c-6.27.56-9.38-1.79-9.38-1.79s-8.6-34.62-11-45.32-8.61-48.74-8.61-48.74l-4.05,24.19a83.09,83.09,0,0,1-.84,25.95c-3.11,15.4-7.08,28.62-7.08,28.62a31.87,31.87,0,0,1-9.19,1.13,20.57,20.57,0,0,1-9.74-2.91s-.5-38.56-.5-56.23,1.87-60.94,3.49-87.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.63,224.05l-5.6-34s-11.81-.84-18.38-7.71c2.66,7.3,12.36,12.41,16.62,13.43l5,27.87-1.69,24.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.5,161.66a42.07,42.07,0,0,1,3.84,8.11,76.36,76.36,0,0,1,2.55,8.6,88,88,0,0,1,1.62,8.81,56.74,56.74,0,0,1,.59,8.94c-.71-2.91-1.37-5.8-2-8.68s-1.31-5.77-2-8.64-1.38-5.73-2.12-8.59S419.4,164.52,418.5,161.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.41,162.74a31.62,31.62,0,0,1,4,4.54,43.9,43.9,0,0,1,3.29,5.1,40,40,0,0,1,2.49,5.55,23.67,23.67,0,0,1,1.37,5.93l-2.72-5.35c-.92-1.75-1.83-3.5-2.79-5.23s-1.92-3.46-2.87-5.21S423.29,164.58,422.41,162.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,198.49c1.29,9.26,2.44,18.54,3.61,27.81s1.73,21.34,3.43,30.49,3.5,18.36,5.13,27.56,3.19,18.42,4.6,27.66q-3.19-13.67-6.05-27.38c-1.92-9.15-3.73-18.29-5.53-27.5s-2.13-21.36-3-30.67S416.48,207.83,415.92,198.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.87,199.26l-1.53,24.37c-.22,4.06-.48,8.11-.67,12.17s-.42,8.13-.36,12.14-.29,33.77-.95,50.53c-.58-13.45-.65-42.3-.93-50.5,0-8.24.73-16.33,1.45-24.46S383.61,207.31,384.87,199.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.21,105.39c-7.48.82-12.07,2.58-19.2,15.88-4.64,8.64-9.83,19.39-9.83,19.39s-25.28.89-29.78.72c-5.11-.18-6.93-3.81-9.11-5.35s-6.32-4.65-7.93-6.15c-1.33-1.24-2.33.35-2,1.83.5,2.35,2.62,4,3.36,5.19s.59,2.49-.82,2-6.36-2.68-8.06-3.4-3.18-2.52-5.21-2.28-2.65,1-1.59,2.06a49.41,49.41,0,0,0,8.27,5.9c1.24,1.85,1.62,8.86,4.7,10.63a35.75,35.75,0,0,0,7.79,2.86c2.82.73,7.58-.81,11.47-.76,2.44,0,13.33,1.83,24.69,3.29,10.95,1.4,13.43,1.74,18.06-5.67a185.22,185.22,0,0,0,12.18-24.34Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.59,146.19c-2.29-1.81-7.7-2.37-11.71.63L316,146S322.86,140.94,328.59,146.19Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.14,152.44a17.77,17.77,0,0,1-5.55-3.36,2.42,2.42,0,0,1-.3-2.27,2.39,2.39,0,0,1-.82-1.92c0-1.08.7-1.3,1.23-1.77-1.11-1.33-2.34-2.8-1.07-4s3.54-2.16,4.83-1.89c.84.17,2.4,1.84,3.53,2.78a4.81,4.81,0,0,1,.88.85c.24.63-.77,1.28-1.59,1.23,1.32.78,3.05,1.17,2.77,2.22a2.1,2.1,0,0,1-2.22,1.32c.56.29,1.16.4,1.25.88s-.79,2.07-3,1.52C313.41,148.19,312.64,150.22,315.14,152.44Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.28,142.08c.48.25,1,.43,1.49.66a2.67,2.67,0,0,1,1.35,1,1.42,1.42,0,0,1-.61,1.56,2.39,2.39,0,0,1-1.64.38l.07-.21c.23.14.46.29.68.45a3.92,3.92,0,0,1,.32.25.58.58,0,0,1,.24.38,1.07,1.07,0,0,1-.3.78,2.4,2.4,0,0,1-.65.5,2.34,2.34,0,0,0,.58-.55,1,1,0,0,0,.22-.7c0-.24-.31-.34-.52-.5l-.69-.41-.45-.28.53.06a2.13,2.13,0,0,0,1.45-.37,1.18,1.18,0,0,0,.55-1.24,2.76,2.76,0,0,0-1.2-1A14.27,14.27,0,0,1,316.28,142.08Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.73,145.53c-.68-.24-1.33-.54-2-.8a5.78,5.78,0,0,0-1-.32,2,2,0,0,0-1,.12,8.85,8.85,0,0,0-1.84,1l-.88.61a2.41,2.41,0,0,0-.75.74,4.76,4.76,0,0,1,1.51-1.52,7.67,7.67,0,0,1,1.87-1.12,2.25,2.25,0,0,1,1.12-.11,4.42,4.42,0,0,1,1,.37C315.47,144.84,316.09,145.2,316.73,145.53Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.35,142.63c-.82-.36-1.63-.74-2.43-1.13a2.55,2.55,0,0,0-2.46.21,26.43,26.43,0,0,0-2.35,1.25c-.72.46-1.6,1-1.64,1.93a1.66,1.66,0,0,1,.48-1.24,6.16,6.16,0,0,1,1.05-.86,22.55,22.55,0,0,1,2.35-1.33,4.83,4.83,0,0,1,1.3-.42,2.13,2.13,0,0,1,1.36.28C315.79,141.74,316.58,142.18,317.35,142.63Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.61,141.29a3,3,0,0,1-.83-.62,2.23,2.23,0,0,1-.55-.84,2.17,2.17,0,0,0,.64.74,2.69,2.69,0,0,0,.84.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.17,173.15c-2-9.21-4.56-19.53-4.83-21.55-1.57-11.72.51-17.66,1.27-22.79,1.67-11.17-1.53-20.52-4.13-22.72a72.34,72.34,0,0,0-12.27-2.61c-6.58-.85-15.65.13-18.1.47a78.79,78.79,0,0,0-7.9,1.44,36.55,36.55,0,0,0-7.67,9.87c-2.83,5.06-4.44,9.29-4.94,20.13-.64,13.8-1.49,28.13-1.49,37.76C388.54,180.17,422.41,181.75,437.17,173.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358,136.4h0l1.1-1h0a1.34,1.34,0,0,1,1.18-.17l13.61,3.16a4.62,4.62,0,0,1,2.9,2.5l10,25.44a1.19,1.19,0,0,1-.11,1.33h0l-1.14,1.07v0a1.29,1.29,0,0,1-1.19.19l-13.61-3.16a4.6,4.6,0,0,1-2.9-2.5l-10-25.45A1.12,1.12,0,0,1,358,136.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,140.07a4.56,4.56,0,0,1,1.52,1.84l10,25.44a1.23,1.23,0,0,1-.08,1.29l1.08-1h0a1.17,1.17,0,0,0,.12-1.33l-10-25.45a4.56,4.56,0,0,0-1.4-1.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.63,167.35l-10-25.44a4.6,4.6,0,0,0-2.9-2.5l-13.61-3.17c-1.17-.26-1.76.42-1.32,1.53l10,25.45a4.6,4.6,0,0,0,2.9,2.5l13.61,3.16C385.48,169.15,386.07,168.46,385.63,167.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.86,147.32,374,142.56a.84.84,0,0,0-.54-.47l-2.35-.54c-.22-.05-.33.08-.25.28l1.87,4.77a.83.83,0,0,0,.54.46l2.35.54C375.83,147.65,375.94,147.53,375.86,147.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.92,143.72a2.15,2.15,0,0,0-1.38-1.16c-.56-.13-.86.18-.66.69a2.19,2.19,0,0,0,1.38,1.15C373.83,144.53,374.12,144.22,373.92,143.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.83,146.12a2.13,2.13,0,0,0-1.38-1.15c-.56-.13-.85.17-.65.68a2.11,2.11,0,0,0,1.37,1.15C374.74,146.93,375,146.63,374.83,146.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.91,154.39l4.34-27s.22-16.07,6.25-21.34c7,1.92,9,6,10.82,10.36,2.32,5.62,2.13,11,.09,25.3-1.73,12.17-3.87,19.87-5.64,24.32-2.19,5.5-7,6-15.44,5.53s-13.68-1.2-25.35-2.76c-5.62-.75-8.56-2-13.2-3.44a17.45,17.45,0,0,1-5-2.26,10.31,10.31,0,0,1-3.47-3.6,3.12,3.12,0,0,0-.49-.78,5,5,0,0,0-.7-.59,5.88,5.88,0,0,1-1.3-1.14,9.35,9.35,0,0,1-.81-1.65,6.76,6.76,0,0,0-.36-.77,5.2,5.2,0,0,0-.55-.69,6.43,6.43,0,0,1-1.4-1.8,1.2,1.2,0,0,1,.12-1.16s-.78-.61-1-.83a6.37,6.37,0,0,1-1-1,.67.67,0,0,1-.18-.51.7.7,0,0,1,.19-.27c1.26-1.21,3-.71,4.41-.15,3.75,1.44,5.8,3.12,9.7,4.15,2.13.56,2.66.67,3.41.44,1-.64-2.85-4.25-3.15-7.27-.15-1.5,1.21-3.34,2.41-1.62,2.5,3.6,4.67,4.53,6.55,6.59s3.63,3.3,7.6,4.63C400,156.48,418.91,154.39,418.91,154.39Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.91,154.39c4.34-1.09,9.71.42,9.71.42a17.49,17.49,0,0,0-9.48-1.83Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.9,151.16a29.45,29.45,0,0,0,2.41,1.79c.83.58,1.67,1.12,2.49,1.68.41.27.81.57,1.25.84s.87.5,1.32.73c.9.46,1.8.88,2.74,1.25l-1.3-.76c-.44-.24-.87-.49-1.3-.74s-.86-.51-1.27-.78-.81-.57-1.23-.85c-.84-.56-1.68-1.09-2.54-1.61Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.57,154.5a11.84,11.84,0,0,0,1.63,1.69c.59.5,1.21,1,1.83,1.42s1.27.88,1.93,1.28a18.12,18.12,0,0,0,2,1.1c-.64-.44-1.25-.9-1.88-1.34l-1.87-1.34L370.38,156C369.77,155.51,369.16,155,368.57,154.5Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.47,95.1a119.2,119.2,0,0,0,3.28-15.3l-1.38-.42C381.21,76.06,381.52,68,383,63.83c3.35-9.36,13.46-12.87,19.72-13.21C414.6,50,420.4,53,421.62,59.19c1.61-.14,3.82,1.15,5.16,3,2.91,4,4.25,19.25,1.79,31.53,0,0-1.1,1.22-5,2.06a32.07,32.07,0,0,1-5.87.7S394.6,100.59,385.47,95.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.64,89.94a5.48,5.48,0,0,0,5.05-2.29c2.75-3.27,2.89-6.5,1.46-8.6-1.17-1.71-3.93-2.73-5.78-1.47s-2,2.4-2.72,3.87S415,82.91,414,77.13c-.87-5.39-1.89-10.33-4.64-12.67-4.1-3.5-8.49-2.73-10-.51-1.72-2.47-4.22-3.39-6.87-1.84s-4.55,5.68-5.08,16c-.54,10.52,2.17,17,4.65,18.63C394,98,396,98.53,400,98.55l-.14,5.58s-6.43,14.27-6.06,23.26c0,0,3.27-5.7,13-14.25l10.63-9.28L418,88.39A3.37,3.37,0,0,0,420.64,89.94Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,73.06l4-1.14A2,2,0,0,0,391,70.46,2.18,2.18,0,0,0,389.47,73.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.63,72.54l4.2,1.4a2.13,2.13,0,0,0-1.32-2.79A2.33,2.33,0,0,0,403.63,72.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,65.3c.75,1.3,1.05,3.55,1.28,5.72.19,1.75.37,5.86,1.55,8.31a6.36,6.36,0,0,0,4.88,3.82,8.36,8.36,0,0,0,4.12-.42c.8-.37,3.08-2,2.8-4.33a4.72,4.72,0,0,1-1.67,1.18,4.9,4.9,0,0,1-1.51.36,4.59,4.59,0,0,1-3.88-2.15c-1.54-2.28-1.43-5.34-1.9-8-.6-3.31-1.17-7.07-4.16-8.71-3.54-1.94-8.92-.79-9.68,2.82A5.46,5.46,0,0,1,407.57,65.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.16,87l-5.7,1.85a3,3,0,0,0,4.05,1.83A2.82,2.82,0,0,0,405.16,87Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,90.87a3.14,3.14,0,0,1,3.16-2.8,2.85,2.85,0,0,1,.29,0,2.65,2.65,0,0,1-1.8,2.6A3.5,3.5,0,0,1,401.86,90.87Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.88 74.81 399.11 85.15 393.43 83.22 399.88 74.81",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,98.55a36.53,36.53,0,0,0,11.11-2.5c1.29-.57,3-2.94,4.4-5.58,0,0-.94,5.18-3.72,7-4.23,2.75-11.86,3.4-11.86,3.4Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.78,77c-.26.85.33,1.11,1.16,1.37s1.55.4,1.82-.45a1.59,1.59,0,0,0-1-2A1.61,1.61,0,0,0,390.78,77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53,76.23a4.09,4.09,0,0,0-1.18-.39,3.51,3.51,0,0,0-1.21,0,3.77,3.77,0,0,0-1.22.4s-.05.1,0,.1a10.29,10.29,0,0,1,1.09-.15,6.15,6.15,0,0,1,1.36.12,5.88,5.88,0,0,1,1.56.53l.5.25c.05,0,.08-.09.06-.13A2.73,2.73,0,0,0,393.53,76.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.61,77.16c.22.87-.39,1.1-1.22,1.31s-1.58.33-1.8-.54a1.58,1.58,0,0,1,1.1-2A1.61,1.61,0,0,1,406.61,77.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,76.22a4.1,4.1,0,0,1,1.2-.32,3.28,3.28,0,0,1,1.21,0,4.06,4.06,0,0,1,1.2.46s0,.11,0,.1c-.33-.06-.62-.14-1.09-.19a5.25,5.25,0,0,0-1.37,0,6,6,0,0,0-1.57.44L403,77s-.08-.09,0-.13A2.84,2.84,0,0,1,403.9,76.22Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.26,77.17c8.14-7.08,8.58-19.42,2.6-28.54-4.13-6.29-12.11-9.94-21.81-9.94s-18.47,3.59-23.68,9.74a21.44,21.44,0,0,0-1.93,24.46c4.57,8,21.21,15.28,38.07,8.25l9,4.56a.66.66,0,0,0,.91-.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.81,86.16a1,1,0,0,1-.48-.12l-8.83-4.47c-16.82,6.92-33.68-.26-38.39-8.49a21.85,21.85,0,0,1,2-24.9c5.24-6.18,14.2-9.88,24-9.88S362,42,366.18,48.42c6.3,9.61,5.23,22-2.46,28.86l3.06,7.43a1,1,0,0,1-.26,1.17A1.06,1.06,0,0,1,365.81,86.16Zm-9.28-5.44,9.15,4.63a.27.27,0,0,0,.31,0,.25.25,0,0,0,.07-.31l-3.26-7.94.21-.18c7.58-6.61,8.67-18.66,2.53-28-4.07-6.21-11.9-9.77-21.49-9.77s-18.3,3.59-23.39,9.6a21.08,21.08,0,0,0-1.88,24c4.58,8,21.1,15,37.59,8.09Z",
    style: {
      fill: "#1473E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.26,69.75a8.86,8.86,0,0,0-8.81-7.88h-5.39a8.85,8.85,0,0,0-8.8,7.88l-.22,2q13,3.83,23.44,0Zm-11.5-10a6.23,6.23,0,1,0-6.23-6.23A6.23,6.23,0,0,0,343.76,59.8ZM335.43,58a1,1,0,0,0-1-1h-2.84V54.19a1,1,0,1,0-1.93,0V57h-2.84a1,1,0,1,0,0,1.92h2.84v2.84a1,1,0,0,0,1.93,0V59h2.84A1,1,0,0,0,335.43,58Z",
    style: {
      fill: "#455a64"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNouserdata);
export default __webpack_public_path__ + "static/media/nouserdata.01cfb36833e873f1053bbbfae1c101d1.svg";
export { ForwardRef as ReactComponent };